import React from 'react'

import Image from 'next/image'

import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import { Column, Text } from 'Components/UI'

import { StripedCircleSvg } from 'Assets/Svg'

import { useResponsiveLayout } from 'Hooks'

import { HERO_AVATARS_ITEMS } from './constants'
import { Avatar, Avatars, CommunityHolder, Container, Content } from './styles'

function ExecutiveInviteHeroSectionTitle() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()

  const centered = !isWideDesktop

  return (
    <Container alignItems={centered ? 'center' : 'flex-end'}>
      <Column>
        <AppearingWrapper centered={centered} kind="expand">
          <Content
            flexDirection={[
              'column',
              'column',
              'column',
              'column',
              'column',
              'row',
            ]}
          >
            {StripedCircleSvg()}

            <Text as="h1" bold center={centered} important screen18>
              Networking for Entrepreneurs & Executives
            </Text>
          </Content>
        </AppearingWrapper>

        <Text accent as="h3" bold center={centered} mb={5} mt={4} screen40>
          Australia&#39;s #1 Golf & Business Networking Community
        </Text>

        <Text body center={centered} mb={11} screen20>
          $30M+ in business closed by members already
        </Text>

        <CommunityHolder
          flexDirection={isDesktop ? 'row' : 'column'}
          justifyContent={isDesktop ? 'flex-start' : 'center'}
          mb={isDesktop ? 0 : 5}
        >
          <Avatars>
            {HERO_AVATARS_ITEMS.map((item, index) => (
              <Avatar key={item.id} left={index * 30} zIndex={2 - index}>
                <Image
                  alt={item.imageAlt}
                  height={42}
                  src={item.image}
                  width={42}
                />
              </Avatar>
            ))}
          </Avatars>

          <Text body center={!isDesktop} screen20>
            7540+ Community
            <br />
            90+ networking events per annum
          </Text>
        </CommunityHolder>
      </Column>
    </Container>
  )
}

export default ExecutiveInviteHeroSectionTitle
